import { styled as e } from "styled-components";
import { Theme as o } from "../../../styles/themes/index.js";
const t = e.label`
  background: 0;
  position: relative;
  cursor: pointer;
  display: flex;

  ${(r) => r.disabled && "pointer-events:none;"}

  input {
    display: none;
  }
`, l = e.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 64px;
  height: 64px;
  border: 2px solid rgb(${o.colors.Golf});
  border-radius: 50%;
  background-color: rgb(${o.colors.Juliet});
`;
export {
  t as Container,
  l as LoadingContainer
};
